import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../../core/services/alert/alert.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { cloneDeep } from 'lodash-es';
import { EnfafModalComponent } from "../../enfaf-modal/enfaf-modal.component";

@Component({
    selector: 'app-modal-diploma',
    imports: [MatDialogModule, MatIconModule, MatButtonModule, EnfafModalComponent],
    templateUrl: './modal-diploma.component.html',
    styleUrl: './modal-diploma.component.scss'
})
export class ModalDiplomaComponent implements OnInit {
  freeCourseCompleted = false;
  courseName!: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalDiplomaComponent>,
    private alert: AlertService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    const receivedData = this.data ? cloneDeep(this.data) : null;
    const { freeCourseCompleted, courseName } = receivedData;
    if (!courseName) {
      this.closeModal();
      return;
    }

    this.freeCourseCompleted = freeCourseCompleted;
    this.courseName = courseName;
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  goToWhatsapp(): void {
    const identity = this.auth.getIdentity();
    if (!identity) return;

    let url = '';
    if (this.freeCourseCompleted) {
      url = `https://api.whatsapp.com/send/?phone=34623569308&text=Hola%21+me+gustaría+recibir+mi+Diploma+del+Curso+de+Fundamentos+Básicos+de+la+Mecánica+del+Ejercicio.+Mi+nombre+es+${identity.name}+${identity.lastname}+y+mi+correo+es+${identity.email}&type=phone_number&app_absent=0`;
    } else {
      const courseName = this.courseName.trim().replace('\n', '+');
      url = `https://api.whatsapp.com/send/?phone=34623569308&text=Hola%21+me+gustaría+recibir+mi+Diploma+del+Curso+${courseName}.+Mi+nombre+es+${identity.name}+${identity.lastname}+y+mi+correo+es+${identity.email}&type=phone_number&app_absent=0`;
    }
    window.open(url, '_blank');
  }
}
